module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "bg4"
  }, [_c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cen_tt"
  }, [_c('i', [_c('b', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("During the summer of 2016, my daughter-in-law, Celia, requested a unicorn quilt for Christmas. Celia was specific: There had to be a big rainbow, a happy unicorn, and lots of pink—and it had to be big enough to snuggle under. Even though this was pretty far from the quilts I normally make, I said “Sure. I can do that!”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I wasn’t excited about this quilt until I was in the middle of making it. Unicorns are magical and happy—just looking at it makes me grin!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Thank you, Celia!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0f0a57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_dedicationtitle.vue
// module id = 63
// module chunks = 0